import { jsx } from "react/jsx-runtime";
import { Divider } from "@zillow/constellation-10";
import { resolveSpacing } from "@zillow/zrs-cms";
const APPEARANCE_MAP = {
  regular: "muted",
  emphasized: "emphasized"
};
const BlockDivider = ({
  attrs
}) => {
  const {
    appearance,
    tone,
    margin = {
      marginBottom: {
        default: "tighter"
      }
    }
  } = attrs;
  const resolvedTone = tone ?? APPEARANCE_MAP[appearance ?? ""];
  const cssParts = {};
  if (margin) {
    for (const [k, v] of Object.entries(margin)) {
      const migrated = resolveSpacing(v);
      if (migrated !== void 0) cssParts[k] = migrated;
    }
  }
  const dividerProps = {
    ...resolvedTone && {
      tone: resolvedTone
    },
    ...Object.keys(cssParts).length > 0 && {
      css: cssParts
    }
  };
  return /* @__PURE__ */ jsx(Divider, { ...dividerProps });
};
export {
  BlockDivider as default
};
